(function () {
  'use strict';
  var scheduled = false;
  var observer;
  function syncNameRule() {
    var rule = document.getElementById('ik-name-field-rule');
    if (!rule) return;
    var input = document.querySelector('#cf_90[name="properties[Name]"]');
    if (!input) return;
    var max = Number(rule.getAttribute('data-max'));
    var min = Number(rule.getAttribute('data-min'));
    if (input.maxLength !== max) input.maxLength = max;
    var wrapper = input.closest('.so-input-counter-w');
    var counter = wrapper && wrapper.querySelector('.so-counter');
    var count = (input.value || '').length + '/' + max;
    if (counter && counter.textContent !== count) counter.textContent = count;
    var help = document.getElementById('ik-name-field-help');
    if (!help && wrapper) {
      help = document.createElement('p');
      help.id = 'ik-name-field-help';
      help.className = 'ik-name-field-help';
      help.textContent = 'Enter ' + min + '–' + max + ' letters (A–Z).';
      wrapper.insertAdjacentElement('afterend', help);
    }
    var described = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (help && described.indexOf(help.id) < 0) {
      described.push(help.id);
      input.setAttribute('aria-describedby', described.join(' '));
    }
    input.setCustomValidity('');
    if ((input.value || '').length > max || input.validity.patternMismatch || input.validity.tooShort) {
      input.setCustomValidity('Please enter ' + min + '–' + max + ' letters (A–Z).');
    }
  }
  function syncMenu() {
    var menu = document.getElementById('menu');
    if (!menu) return;
    var back = document.getElementById('ik-menu-back');
    if (!back) {
      back = document.createElement('button');
      back.id = 'ik-menu-back';
      back.type = 'button';
      back.className = 'ik-menu-back';
      back.setAttribute('aria-label', 'Back to menu');
      back.hidden = true;
      back.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        // Mmenu's existing navbar click returns to the parent panel.
        menu.click();
        schedule();
      });
      menu.insertBefore(back, menu.firstChild);
    }
    back.hidden = !menu.querySelector('ul.mm-spn--parent');
  }
  function syncSearch() {
    var panel = document.querySelector('.js-search-bar-wrapper');
    var trigger = document.querySelector('.js-search-bar-button');
    if (panel && trigger) {
      if (!panel.id) panel.id = 'ik-product-search';
      trigger.setAttribute('aria-controls', panel.id);
      var visible = window.getComputedStyle(panel).display !== 'none' && panel.getBoundingClientRect().height > 0;
      trigger.setAttribute('aria-expanded', visible ? 'true' : 'false');
    }
    document.querySelectorAll('.top-search-close, .search-close').forEach(function (close) {
      close.setAttribute('aria-label', 'Close search');
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
    });
    document.querySelectorAll('form[role="search"] button, .search_form button[type="submit"]').forEach(function (submit) {
      submit.setAttribute('aria-label', 'Search products');
    });
  }
  function sync() {
    scheduled = false;
    syncNameRule();
    syncMenu();
    syncSearch();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(sync);
  }
  function init() {
    sync();
    document.addEventListener('input', schedule, true);
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', schedule, true);
    document.addEventListener('keydown', function (event) {
      var target = event.target;
      if (target && target.matches('.js-search-bar-button, .top-search-close, .search-close') &&
          (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        target.click();
        schedule();
      }
    });
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'maxlength', 'pattern'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
